export default "__VITE_ASSET__DB2f$IwM__"